import React from "react";
import { Box, Container, Typography } from "@mui/material";
import "./FooterAllReserved.css";
import { useTranslation } from "react-i18next";
export const FooterAllReserved = () => {
  const currentYear = new Date().getFullYear();
  return (
    <Box className="footer-all-reserved">
      <Container className="container" maxWidth={false} disableGutters>
        <Typography
          className="footer-all-reserved__heading"
          component={"span"}
          sx={{ display: "block" }}
        >
          {`Copyright © 2024 - ${currentYear} enomo.casino.`}
          <p>All rights reserved</p>
        </Typography>
      </Container>
    </Box>
  );
};
